import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Custom
import { openDialog } from 'actions';
import { getHocDisplayName } from 'utils/Tools';

const withMessageDialog = (WrappedComponent, options = {}) => {
  const { withRef = false } = options;

  class WithMessageDialog extends React.Component {
    constructor(props) {
      super(props);

      this.handleDisplayMessage = this.handleDisplayMessage.bind(this);
    }

    getWrappedInstance() {
      return withRef ? this.wrappedInstance : null;
    }

    // Handlers
    handleDisplayMessage(id, values = {}, level = 'danger', closeOtherDialogs = false) {
      const { handleOpenDialog } = this.props;
      handleOpenDialog({
        component: {
          type: 'INFO_MESSAGE',
          props: {
            message: { id, values, level },
          },
        },
      }, closeOtherDialogs);
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleDisplayMessage={this.handleDisplayMessage}
          ref={withRef ? (wi) => { this.wrappedInstance = wi; } : null}
        />
      );
    }
  }

  WithMessageDialog.displayName = getHocDisplayName('WithMessageDialog', WrappedComponent);

  WithMessageDialog.propTypes = {
    handleOpenDialog: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = (dispatch) => ({
    handleOpenDialog: (props, closeOthers) => {
      dispatch(openDialog(props, closeOthers));
    },
  });

  return connect(
    null,
    mapDispatchToProps,
  )(WithMessageDialog);
};

export default withMessageDialog;



// WEBPACK FOOTER //
// ./hocs/WithMessageDialog.js